import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { map } from 'rxjs/operators';

import { LogoffService } from 'auth/logoff.service';
import { CampaignCreateDialog } from 'campaign/dialogs/campaign-create.dialog';

import { GetAssessmentInfoQueryGQL } from 'generated/graphql';

/**
 * - When no campaigns and user is admin and asssements are default, tell admin to set assessment levels.
 * - When no campaigns and user is admin and assessments are not default, tell admin create campaign
 * - When no campaigns and user user is lead, allow lead to create campaign
 * - when organizer / activist and no campaigns, tell them to contact an admin
 */
@Component({
  selector: 'app-no-campaigns',
  templateUrl: './no-campaigns.page.html'
})
export class NoCampaignsPage {

  /**
   * Used when a user is an admin to send them to the
   * page to set up assessments before they create a campaign.
   */
  areAssessmentsDefault$ = this.getAssessmentInfoQueryGQL
    .fetch(null, { fetchPolicy: 'network-only' })
    .pipe(
      map(result => result.data.getAssessmentInfo.isDefault)
    );
  /**
   *
   */
  constructor(
    private logoffService: LogoffService,
    private dialog: MatDialog,
    private router: Router,
    private getAssessmentInfoQueryGQL: GetAssessmentInfoQueryGQL
  ) {
  }

  onClickSignOut() {
    this.logoffService.logoff();
  }

  openCreateCampaignDialog() {
    const dialogRef = this.dialog.open(CampaignCreateDialog, {});

    dialogRef.afterClosed().subscribe((result: { id: string }) => {
      // If a campaign was created navigate to the customize page.
      if (result) {
        this.router.navigate(['/campaign/customize'], { queryParams: { campaignId: result.id } });
      }
    });
  }
}
